import { useCallback } from "react";

export function useCompleteCheckout(onSuccess?: () => void) {
  return useCallback(
    async (status: "SUCCESS" | "FAILED") => {
      if (!window.opener) {
        onSuccess?.();
        return;
      }

      const messageChannel = new MessageChannel();

      try {
        const acknowledgePromise = new Promise((resolve) => {
          messageChannel.port1.onmessage = (event) => {
            if (event.data === "ACKNOWLEDGED") {
              resolve(null);
            }
          };
        });

        const payload = {
          type: "CHECKOUT_COMPLETE",
          status,
        };

        window.opener.postMessage(payload, "*", [messageChannel.port2]);

        await Promise.race([
          acknowledgePromise,
          new Promise((resolve) => setTimeout(resolve, 10_000)),
        ]);
      } finally {
        messageChannel.port1.close();
        messageChannel.port2.close();
        onSuccess?.();
      }
    },
    [onSuccess],
  );
}
